module.exports = __webpack_public_path__ + "static/media/Logo-square.b2def116.png";